/* Progressive enhancement: native links and details remain usable without JS. */
document.addEventListener('click', (event) => {
  document.querySelectorAll('.mhb-mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.mhb-mobile-menu[open]');
  if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
});
